import {useFormContext} from "react-hook-form";
import {MultiValue, SingleValue} from "react-select";

import {SelectField, SelectFieldBaseProps} from "@/components/form/fields/SelectField/SelectField.tsx";
import {UserSelect} from "@/components/UserSelect/UserSelect.tsx";
import {AccountUser} from "@/lib/types/accounts.ts";

interface UserSelectFieldProps extends SelectFieldBaseProps {
  users: AccountUser[];
  isMulti?: boolean;
}

export const UserSelectField = ({name, users, isMulti, ...rest}: UserSelectFieldProps) => {
  const {setValue, watch} = useFormContext();
  const selectedIds = watch(name);
  const selectedUsers = users.filter((mg) => Array.isArray(selectedIds) && selectedIds.includes(mg.id));
  return (
    <SelectField
      name={name}
      clearErrorsOnChange
      {...rest}
      select={
        <UserSelect
          options={users}
          value={selectedUsers}
          onChange={(data) => {
            if (!isMulti) {
              setValue(name, [(data as SingleValue<AccountUser>)?.id]);
            } else {
              setValue(
                name,
                (data as MultiValue<AccountUser>).map((v: AccountUser) => v.id)
              );
            }
          }}
          isMulti={isMulti}
        />
      }
    />
  );
};
